import Vue from "vue";

export const FORM_SECTIONS_VALIDATION_STATE      = 'formSection/formSectionsValidationState';
export const MUTATE_SET_SECTION_VALIDATION_STATE = 'formSection/setSectionValidateState';

export const FORM_FIELDS_VALIDATION_STATE        = 'formSection/fieldsValidationState';
export const MUTATE_SET_FIELDS_VALIDATION_STATE  = 'formSection/setFieldsValidationState';

const state = {
  sections: {
    admission   : true,
    pregnancy   : true,
    medHistory  : true,
    obScore     : true,
    delivery    : true,
    gyne        : true,
    procedures  : true,
    migsInfo    : true,
    discharge   : true
  },
  fields: []
};

const getters = {
  [FORM_SECTIONS_VALIDATION_STATE]: (state) => state.sections,
  [FORM_FIELDS_VALIDATION_STATE]: (state) => state.fields
};

const mutations = {
  [MUTATE_SET_SECTION_VALIDATION_STATE]: (state, {key, value}) => {
    Vue.set(state.sections, key, value)
  },
  [MUTATE_SET_FIELDS_VALIDATION_STATE]: (state, payload) => {
    state.fields = payload
  }
};


export default {
  state,
  getters,
  mutations
}
